<template>
    <router-view/>

</template>

// https://stackoverflow.com/questions/61396466/how-to-disable-a-vuejs-router-link

<script setup>

  import { useConnectionStore } from './stores/connectionStore';
  import { ref, watch, onMounted, onUnmounted } from 'vue'
  import { useWindowSizeStore } from './stores/windowSizeStore';
  import { forceColorsById } from '@/composables/forceColors.js'
  import { useRouter } from 'vue-router';
  import { getOS } from '@/composables/getData.js'

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()
  var userData = connectionStore.getStoredUserData
  //console.log("store in app before startupcheck",userData)
  
  const isDark = ref(userData.darkmode != "light")
  
  const processWindowSizeChange = debounce(() => windowSizeChange(),250)
  const processVisualPortSizeChange = debounce(() => windowSizeChange(),250)

  windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)

  function debounce(callback, interval=500) {
    let debounceTimeoutId;

    return function(...args) {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }

  function windowSizeChange() {
     //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
     windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }
  
  const onResizeChange = () => {
    //console.log("**** on resize change")
    processWindowSizeChange()

    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  const onVisualViewportChange = () => {
    //console.log("**** visual viewport change")
    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    processVisualPortSizeChange()
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  onMounted(() => {
    window.addEventListener('resize', onResizeChange)

    visualViewport.addEventListener('resize', onVisualViewportChange)

    var element = document.getElementById("app")
    element.style.height = "100vh"
    element.style.width = "100vw"

    // set the background for the page
    forceColorsById("app",userData.darkmode)

    // stop scrolling on IOS
    // https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/#:~:text=The%20most%20straightforward%20way%20for,you%20can%20stop%20reading%20here.

    const osName = getOS(false)
    const osNumber = getOS(true)
    windowSizeStore.updateStoredOSInfo(osName,osNumber)
    
    if (osName == 'iOS') {
      const $body = document.querySelector('body');
      let scrollPosition = 0;

      scrollPosition = window.pageYOffset;
      $body.style.overflow = 'hidden';
      $body.style.position = 'fixed';
      //$body.style.top = `-${scrollPosition}px`;
      $body.style.width = '100%';
      window.scrollTo(0, scrollPosition);
    }
  
   
  })

  onUnmounted(() => window.removeEventListener('resize', onResizeChange))

  if (connectionStore.getIsEyeGaze) {
    const router = useRouter()
    router.push("/eyegazemenu")
  }
  
</script>

<style>

* {
  margin : 0;
  padding : 0;
  box-sizing: border-box;
}

:root {
    --sat: env(safe-area-inset-top);
    --sar: env(safe-area-inset-right);
    --sab: env(safe-area-inset-bottom); /* THIS ONE GETS US THE HOME BAR HEIGHT */
    --sal: env(safe-area-inset-left);
}

body {
  font-family: Arial, Helvetica, sans-serif;

  /* try preventing any overflow at the page level. then turn on at individual elements as needed */
  overflow: hidden;

}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.position-relative-container {
  position : relative;
}

/* add form css from brad */

/* Button Styling */
.btn {
  background: #4c6ca0;
  color: #fff;
  border: none;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn:hover {
  color: #f4f4f4;
  background: #446190;
}

a {
  text-decoration: none;
}

  #form-container {
    font-family: "Nunito", sans-serif;   /* rounded */
    line-height: 1.8;
    margin: 30px auto;
    margin-top : 10px;
    max-width: 600px;
    max-height : 70%;
    padding: 20px;
    border-width : 1px;
    border-style : solid;
    overflow-y: auto;

  }

  .form-wrap {
    padding: 15px 25px;
  }

  .form-wrap h1,
  .form-wrap h2,
  .form-wrap h3,
  .form-wrap h4,
  .form-wrap h5,
  .form-wrap p {
    text-align: center;
  }

  .form-wrap .form-group {
    margin-top: 15px;
  }

  .form-wrap .form-group label {
    display: block;
  }

  .form-wrap .form-group input {
    width: 100%;
    padding: 10px;
    border-width : 1px;
    border-style : solid;
    border-radius: 5px;
  }

  .form-wrap button {
    display: block;
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    background: #49c1a2;
    color: #fff;
    cursor: pointer;
  }

  .form-wrap button:hover {
    background: #37a08e
  }

/* henry */

#text-container {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    line-height: 1.4;
    margin : 30px auto;
    margin-top : 10px;
    max-width: 90%;
    max-height : 80%;
    padding: 20px;
    border-width : 1px;
    border-style : solid;
    overflow-y: auto;
  }

  .text-wrap {
    padding: 15px 25px;
  }

  .text-wrap h1,
  .text-wrap h2,
  .text-wrap h3,
  .text-wrap h4,
  .text-wrap h5 {
    text-align: center;
  }

  .text-wrap p {
    padding-top : 1em;
  }

.text-dark {
  color : white;
  background-color : black;
  border-color: white;
}

.text-light {
  background-color : white;
  color : black;
  border-color : black;
}

/* from w3school */

/* Customize the label (the container) */
.radio-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .radio-checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .radio-checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.radio-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .radio-checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .radio-checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border-style : solid;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* used for anything that wants a box that fills up most of the screen */
.chessvis-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin-top : 20px;
  margin-left : 5px;
  margin-right : 5px;
  padding : 15px 15px;
  line-height: 1.4em;
  width : 90%;
  height: calc(100vh - 175px);
  overflow-y: auto;
}

</style>
